/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import React, {
  useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { isUserBidder, isUserHighestBidder } from 'utils/bidHelper';
import { UserContext } from 'contexts/userContext';
import { getHighestBidder } from 'models/marketplace';

const AuctionResult = ({ machine, offers, isTimeOver }) => {
  const { userData, isLoggedIn } = useContext(UserContext);

  const [isAuctionResultHandled, setIsAuctionResultHandled] = useState(false);
  const [resultType, setResultType] = useState();

  useEffect(() => {
    if (
      isTimeOver
      && isLoggedIn
      && offers?.length
      && !isAuctionResultHandled
    ) {
      handleAuctionResult();
    }
  }, [isTimeOver, isLoggedIn, offers, isAuctionResultHandled]);

  const resultMessages = {
    winnerBeforePayment: (
      <>
        <div className="fw-900 text-green2 im-blink">
          Tebrikler, En Yüksek teklifi vererek makinayı almaya hak kazandınız.
        </div>
        <div className="fs-13 text-green2 mt-3">
          Makina alış işlemini onaylamak için
          {' '}
          <Link href={`/checkout/${machine.id}`}>
            <a style={{ color: 'inherit', textDecoration: 'underline' }}>tıklayınız</a>
          </Link>
          .
        </div>
      </>
    ),
    winnerAfterPayment: (
      <>
        <div className="fw-900 text-green2 im-blink">
          Bu makinayı satın aldınız.
        </div>
        <div className="fs-13 text-green2 mt-3">
          Satın alımlarınızı görmek için
          {' '}
          <Link href="/profile/purchases">
            <a style={{ color: 'inherit', textDecoration: 'underline' }}>tıklayınız</a>
          </Link>
          .
        </div>
      </>
    ),
    winnerBelowReservedPrice: (
      <div className="fw-900 text-yellow2 im-blink">
        En yüksek teklifi verdiniz, fakat teklifiniz makinanın belirlenen minimum satış fiyatının altında kaldı. Verdiğiniz teklif makina sahibi tarafından kabul edilirse makinayı almaya hak kazanacaksınız.
      </div>
    ),
    lowerBidder: (
      <div className="fw-900 text-red2 im-blink">
        Üzgünüz, Teklifiniz en yüksek teklifin altında kaldığı için makinayı satın alamadınız.
      </div>
    ),
    notBidder: (
      <>
        <div className="fw-900 text-gray3 im-blink">
          Bu açık arttırma sona ermiştir, bu makinaya artık teklif veremezsiniz.
        </div>
        <div className="fs-13 text-gray3 mt-3">
          Diğer makinalarımıza göz atmak için
          {' '}
          <Link href="/machinery">
            <a style={{ color: 'inherit', textDecoration: 'underline' }}>tıklayınız</a>
          </Link>
          .
        </div>
      </>
    ),
  };

  const handleAuctionResult = async () => {
    if (isUserBidder(userData?.id, offers)) {
      let isCurrentUserHighestBidder;
      if (machine.state === 'IN_EVENT') {
        // Scheduler didn't run yet, so get the highest bidder from the API
        // in case there are new last-second offers the frontend isn't aware of
        const highestBidder = await getHighestBidder(machine.id);
        isCurrentUserHighestBidder = highestBidder === userData.id;
      } else {
        // If scheduler has run, we can safely use the local data
        isCurrentUserHighestBidder = isUserHighestBidder(userData.id, offers);
      }

      if (isCurrentUserHighestBidder) {
        if (machine.state === 'SOLD') {
          setResultType('winnerAfterPayment');
        } else if (offers[0].offer >= machine.reservedPrice) {
          // machine.state === 'SUSPENDED'
          setResultType('winnerBeforePayment');
        } else {
          // machine.state === 'UNSOLD'
          setResultType('winnerBelowReservedPrice');
        }
      } else {
        setResultType('lowerBidder');
      }
    } else {
      setResultType('notBidder');
    }

    setIsAuctionResultHandled(true);
  };

  if (!isAuctionResultHandled) {
    return <></>;
  }
  return (
    <div className="col text-center mb-4">
      {resultMessages[resultType]}
    </div>
  );
};

AuctionResult.propTypes = {
  machine: PropTypes.object,
  offers: PropTypes.array,
  isTimeOver: PropTypes.bool,
};

export default AuctionResult;
